// sp navigation
$(function(){
  $('.sp_nav .hamburger').on('click',function(){
    $(this).parent('.sp_nav').addClass('is-active');
  });
  $('.nav__item a').on('click',function(){
    $('.sp_nav').removeClass('is-active');
  });
  $('.sp_nav .close_btn').on('click',function(){
    $(this).parents('.sp_nav').removeClass('is-active');
  });
});

// pc navigation
$(function(){
  const nav = $('.pc_nav .nav_inner');
  $(window).on('scroll', function(){
    if($(this).scrollTop() > 100) {
      $(nav).fadeIn(300);
    } else {
      $(nav).fadeOut(300);
    }
  });
});

$(function(){
  $('a[href^="#"]').on('click',function () {
    const speed = 600;
    let href = $(this).attr('href');
    let target = $(href == '#' || href == '' ? 'html' : href);
    let position = target.offset().top;
    $('body,html').animate({ scrollTop: position }, speed, 'swing');
    return false;
  });
});

$(function(){
  const moreNum = 4;
  $('.customer__contents .episode__list li:nth-child(n + ' + (moreNum + 1) + ')').addClass('is-hidden');
  $('.btn_viewmore').on('click', function() {
    $('.episode__list li.is-hidden').slice(0, moreNum).removeClass('is-hidden');
    if ($('.episode__list li.is-hidden').length == 0) {
      $('.btn_viewmore').fadeOut();
    }
  });
});

$(function(){ 
  const flag = 'is-active';
  const dataClose = 'close';
  const dataOpen = 'open';

  $('.btn_acc').on('click', function(){
    let $this = $(this);
    let targetParent = $this.closest('.js-acc-sp');
    let accContent = $this.prev('.episode__acc');
    let btnOffset = $this.closest('.episode_inner').offset().top;
    console.log(btnOffset);
    accContent.slideToggle(function(){
      if (!targetParent.hasClass(flag)) {
        $('html, body').animate({ scrollTop: btnOffset }, 300);
      }
    });

    targetParent.toggleClass(flag);

    if($this.data(dataClose) && $this.data(dataOpen)) {
      let txt = targetParent.hasClass(flag) ? $this.data(dataClose) : $this.data(dataOpen);
      $this.find('button').text(txt);
    }
  });
});

$(window).on('resize', function() {
  if( 'none' == $('.btn_acc').css('pointer-events') ){
    $('.episode__acc').attr('style','');
  }
});
